module.exports = {
  "country": "ES",
  "artist": "Raphael",
  "song": "Yo soy aquél",
  "year": "1966",
  "place": "7",
  "spotify": "4H71d1kJ8DB8J4atO8fbBl"
};